import { render } from "./MessageItem.vue?vue&type=template&id=527551d6&scoped=true"
import script from "./MessageItem.vue?vue&type=script&lang=js"
export * from "./MessageItem.vue?vue&type=script&lang=js"

import "./MessageItem.vue?vue&type=style&index=0&id=527551d6&lang=scss&scoped=true"
import "./MessageItem.vue?vue&type=style&index=1&id=527551d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527551d6"]])

export default __exports__